let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("PhRJW")).then(() => parcelRequire('kQBs8'));